export default {
  API_URL: 'https://taqa-api.cometrootapp.com/api/',
  SANDBOX_URL: 'https://taqasandbox-api.cometrootapp.com/api/'
  // API_URL: 'https://localhost:44365/api',
  // SANDBOX_URL: 'https://localhost:44365/api'
}
